export type PersonaPromptStrategy = 'prepend-default' | 'replace';

/**
 * Merge a persona's `defaultPrompt` with the user's prompt for the chosen
 * {@link PersonaPromptStrategy}.
 *
 * A `string` prompt always yields a `string` — `replace` returns the prompt
 * itself and `prepend-default` joins a (possibly empty) array — so callers
 * that always have a task (e.g. the server launcher's `overrides.prompt`)
 * get a `string` back without a fallback. A `string | undefined` prompt
 * (`replace` with no task) yields `string | undefined`.
 */
export function mergePersonaPrompt(
  defaultPrompt: string | null | undefined,
  prompt: string,
  strategy?: PersonaPromptStrategy,
): string;
export function mergePersonaPrompt(
  defaultPrompt: string | null | undefined,
  prompt: string | undefined,
  strategy?: PersonaPromptStrategy,
): string | undefined;
export function mergePersonaPrompt(
  defaultPrompt: string | null | undefined,
  prompt: string | undefined,
  strategy: PersonaPromptStrategy = 'prepend-default',
): string | undefined {
  if (strategy === 'replace') {
    return prompt;
  }
  return [defaultPrompt, prompt]
    .filter((part): part is string => Boolean(part && part.trim()))
    .join('\n\n');
}
